<div
  class="toolbar"
  (mousedown)="onMousedown($event)"
>
  <div class="toolbar__group">
    <select
      class="toolbar-select"
      title="Estilo do texto"
      [value]="settings.currentFormat"
      (change)="onFormatChange($event)"
    >
      <option value="" disabled selected>Estilo do texto</option>
      <option *ngFor="let style of formatStyles" [value]="style.value">
        {{ style.label }}
      </option>
    </select>
  </div>

  <div class="toolbar__group">
    <button
      type="button"
      class="toolbar__group-button"
      [class.active]="isCommandActive('bold')"
      (click)="onFormatBold()"
      title="Negrito (Ctrl+B)"
      tabindex="-1"
    >
      <i class="fas fa-bold"></i>
    </button>

    <button
      type="button"
      class="toolbar__group-button"
      [class.active]="isCommandActive('underline')"
      (click)="onFormatUnderline()"
      title="Sublinhado (Ctrl+U)"
      tabindex="-1"
    >
      <i class="fas fa-underline"></i>
    </button>

    <button
      type="button"
      class="toolbar__group-button"
      [class.active]="isCommandActive('strikethrough')"
      (click)="onFormatStrikethrough()"
      title="Tachado"
      tabindex="-1"
    >
      <i class="fas fa-strikethrough"></i>
    </button>
  </div>

  <div class="toolbar__group">
    <button
      type="button"
      class="toolbar__group-button"
      [class.active]="isCommandActive('insertUnorderedList')"
      (click)="onFormatUnorderedList()"
      title="Lista não ordenada"
      tabindex="-1"
    >
      <i class="fas fa-list-ul"></i>
    </button>

    <button
      type="button"
      class="toolbar__group-button"
      [class.active]="isCommandActive('insertOrderedList')"
      (click)="onFormatOrderedList()"
      title="Lista ordenada"
      tabindex="-1"
    >
      <i class="fas fa-list-ol"></i>
    </button>
  </div>

  <div class="toolbar__group">
    <button
      type="button"
      class="toolbar__group-button"
      [class.active]="isAlignmentActive('justifyLeft')"
      (click)="onFormatAlignLeft()"
      title="Alinhar à esquerda"
      tabindex="-1"
    >
      <i class="fas fa-align-left"></i>
    </button>

    <button
      type="button"
      class="toolbar__group-button"
      [class.active]="isAlignmentActive('justifyCenter')"
      (click)="onFormatAlignCenter()"
      title="Centralizar"
      tabindex="-1"
    >
      <i class="fas fa-align-center"></i>
    </button>

    <button
      type="button"
      class="toolbar__group-button"
      [class.active]="isAlignmentActive('justifyRight')"
      (click)="onFormatAlignRight()"
      title="Alinhar à direita"
      tabindex="-1"
    >
      <i class="fas fa-align-right"></i>
    </button>

    <button
      type="button"
      class="toolbar__group-button"
      [class.active]="isAlignmentActive('justifyFull')"
      (click)="onFormatAlignJustify()"
      title="Justificar"
      tabindex="-1"
    >
      <i class="fas fa-align-justify"></i>
    </button>
  </div>

  <div class="toolbar__group">
    <div
      class="toolbar__color-picker"
      [class.active]="settings.showTextColorPicker"
    >
      <button
        type="button"
        class="toolbar__group-button color-btn"
        (click)="onToggleTextColorPicker()"
        title="Cor do texto"
        tabindex="-1"
      >
        <i class="fas fa-font"></i>
        <i class="fas fa-caret-down"></i>
      </button>
      <div
        class="toolbar__color-picker-dropdown"
        *ngIf="settings.showTextColorPicker"
      >
        <div class="color-palette">
          <button
            type="button"
            *ngFor="let color of colorPalette"
            class="color-swatch"
            [style.background-color]="color"
            (click)="onApplyTextColor(color)"
            [title]="color"
            tabindex="-1"
          ></button>
        </div>
        <div
          class="color-picker-custom"
        >
          <input
            type="color"
            [(ngModel)]="settings.customTextColor"
            (change)="onCustomTextColorChange()"
            class="color-picker-custom-input"
            tabindex="-1"
          />
          <span>Personalizar</span>
        </div>
      </div>
    </div>

    <div
      class="toolbar__color-picker"
      [class.active]="settings.showBgColorPicker"
    >
      <button
        type="button"
        class="toolbar__group-button color-btn"
        (click)="onToggleBgColorPicker()"
        title="Cor de fundo"
        tabindex="-1"
      >
        <i class="fas fa-fill-drip"></i>
        <i class="fas fa-caret-down"></i>
      </button>
      <div
        class="toolbar__color-picker-dropdown"
        *ngIf="settings.showBgColorPicker"
      >
        <div class="color-palette">
          <button
            type="button"
            class="color-swatch"
            [style.background-color]="color"
            [title]="color"
            (click)="onApplyBackgroundColor(color)"
            *ngFor="let color of colorPalette"
            tabindex="-1"
          ></button>
        </div>
        <div class="color-picker-custom">
          <input
            type="color"
            [(ngModel)]="settings.customBgColor"
            (change)="onCustomBgColorChange()"
            class="color-picker-custom-input"
            tabindex="-1"
          />
          <span>Personalizar</span>
        </div>
      </div>
    </div>
  </div>

  <div class="toolbar-group">
    <button
      type="button"
      class="toolbar__group-button"
      (click)="onInsertLink()"
      title="Inserir link"
      tabindex="-1"
    >
      <i class="fas fa-link"></i>
    </button>

    <button
      type="button"
      class="toolbar__group-button"
      (click)="onRemoveFormat()"
      title="Remover formatação"
      tabindex="-1"
    >
      <i class="fas fa-eraser"></i>
    </button>
  </div>

  <div class="toolbar__group">
    <button
      type="button"
      class="toolbar__group-button"
      (click)="onUndo()"
      title="Desfazer (Ctrl+Z)"
      tabindex="-1"
    >
      <i class="fas fa-undo"></i>
    </button>

    <button
      type="button"
      class="toolbar__group-button"
      (click)="onRedo()"
      title="Refazer (Ctrl+Y)"
      tabindex="-1"
    >
      <i class="fas fa-redo"></i>
    </button>
  </div>
</div>
